import { useMutation, useQueryClient } from "@tanstack/react-query"
import { ApiError, api } from "@/api/client"
import { RefreshBody, RefreshResponse } from "../../../../backend/src/routes/auth/refresh.types"
import { AxiosError } from "axios"

export const refreshTokensRequest = async (body: RefreshBody) => {
    const { data } = await api().post<RefreshResponse>(`/auth/refresh`, body)
    return data
}

export const useRefreshTokensMutation = () => {
    const queryClient = useQueryClient()

    return useMutation<RefreshResponse, AxiosError<ApiError>, RefreshBody>({
        mutationFn: (body: RefreshBody) => refreshTokensRequest(body),
        onSuccess: async () => {
            await queryClient.invalidateQueries()
        },
    })
}
